module.exports = __webpack_public_path__ + "static/media/logo.c827c321.png";